'use client';

import * as React from 'react';
import customCss from '@/app/components/hotel-detail/css/customCss';
import { css } from 'styled-components';
import { LeaderBoard } from '@/app/common/biff/hotelDetailPage/adSlots.tsx';
import { evoSectionGutters } from '@/app/components/hotel-detail/evo/EvoCommon';

type AdsFooterProps = {
  /**
   * Set by layouts that place the ad inside an already-inset content column from lg up
   * (evo details) instead of full-bleed.
   */
  containedFromLg?: boolean;
} & React.HTMLAttributes<HTMLElement>;

export function AdsFooter(props: AdsFooterProps) {
  const { containedFromLg = false, ...rest } = props;

  // Gutters keep the ad off the viewport edges until the layout it sits in insets it itself:
  // straight from the evo sections when it shares their content column, otherwise following the
  // full-bleed grid's own gutters until they take over at xl.
  const sideInset = containedFromLg
    ? evoSectionGutters
    : css`
        padding: 0 16px;

        @media ${customCss.breakpoints.sm} {
          padding: 0 24px;
        }

        @media ${customCss.breakpoints.lgPlus} {
          padding: 0 40px;
        }

        @media ${customCss.breakpoints.xl} {
          padding: 0;
        }
      `;

  return (
    <div
      css={`
        grid-area: ad-bottom;
        margin-top: 16px;
      `}
      {...rest}
    >
      <LeaderBoard adId="div-gpt-ad-bottom3" />
      <div
        id="afs-details-bottom"
        css={css`
          margin-top: 16px;

          ${sideInset}
        `}
      />
    </div>
  );
}
